import { render, staticRenderFns } from "./ManagerContent.vue?vue&type=template&id=147bab7c&scoped=true&"
import script from "./ManagerContent.vue?vue&type=script&lang=js&"
export * from "./ManagerContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bab7c",
  null
  
)

export default component.exports